import { useEffect, useState } from "react";
import { useUpdateSettingMutation } from "../../store/storageRoles/devicesSharedApi";

const useUpdateDeviceSettingData = () => {
  const [
    updateDeviceSetting,
    {
      data: updateDeviceSettingData,
      isLoading: updateDeviceSettingIsLoading,
      isSuccess: updateDeviceSettingIsSuccess,
      isError: updateDeviceSettingIsError,
      error: updateDeviceSettingError,
    },
  ] = useUpdateSettingMutation();

  return {
    updateDeviceSetting,
    updateDeviceSettingIsLoading,
    updateDeviceSettingIsSuccess,
    updateDeviceSettingIsError,
    updateDeviceSettingError,
    updateDeviceSettingData,
  };
};

export default useUpdateDeviceSettingData;
